import { useIntl } from 'react-intl'
import AssistChip from 'LuxKit/Chips/AssistChip'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'

interface Props {
  onClick: () => void
  disabled?: boolean
}

function ChatHotelCarouselMapChip({ onClick, disabled }: Props) {
  const intl = useIntl()
  return <AssistChip variant="outline" size="medium" startIcon={<LineMapIcon />} onClick={onClick} disabled={disabled}>
    {intl.formatMessage({
      id: 'MFJ4gmj1I1tHpP4qblkB',
      defaultMessage: 'Map view',
      description: 'Filter-row action opening the map of hotels in a Trip Planner chat carousel',
    })}
  </AssistChip>
}

export default ChatHotelCarouselMapChip
